import Subscription from 'src/models/Subscription';

/**
 * Returns all of the subscriptions along with their associated plans (if available).
 *
 * @param {Object} state
 * @returns {Subscription[]}
 */
export function subscriptions(state) {
  const { plans = [], subscriptions: subscriptionsData = [] } = state;

  return subscriptionsData.map((subscription) => {
    const planData = plans.find((plan) => plan.sku === subscription.plan.sku);
    return new Subscription({
      ...subscription,
      plan: {
        ...subscription.plan,
        ...planData,
      },
    });
  });
}
